import { useSearchParameters } from 'hooks/useSearchParameters';
import { RadioGroup } from 'components/ControlledInputs/RadioGroup';
import { TableConfig } from 'models/general';

interface Props {
  config: TableConfig;
  title: string;
  choices: { label: string; value: string }[];
  filterField: string;
}

export const FilterOptionList = ({ config, title, filterField, choices }: Props) => {
  const { queryKey, defaultFilters } = config;
  const { setParameters, parameters: filters } = useSearchParameters(queryKey);

  const handleChange = (option: string) => {
    setParameters({ ...filters, [filterField]: option });
  };

  return (
    <RadioGroup
      label={title}
      data={choices}
      onChange={handleChange}
      value={filters[filterField] || defaultFilters?.[filterField] || choices[0].value}
      vertical
    />
  );
};
